import React from "react";
import styles from "./Home.module.css";
import HeroSection from "../components/HeroSection";
import BackToTop from "../components/BackToTop";
import ProjectMap from "../components/ProjectMap";

const Home: React.FC = () => (
  <main className={styles.homePage}>
    <HeroSection />
    <ProjectMap />
    <BackToTop />
  </main>
);

export default Home;
